// -*-mode: rjsx -*-

// REACT
import React, { Component } from "react"
import PropTypes from "prop-types"
import clsx from "clsx"

// ROUTER
// eslint-disable-next-line
import { Link, Redirect } from "react-router-dom"

// MUI
// eslint-disable-next-line
import { lighten, withStyles } from "@material-ui/core/styles"
import CssBaseline from "@material-ui/core/CssBaseline"
import Typography from "@material-ui/core/Typography"
// eslint-disable-next-line
import Paper from "@material-ui/core/Paper"
// eslint-disable-next-line
import Favorite from "@material-ui/icons/Favorite"
// eslint-disable-next-line
import FavoriteBorder from "@material-ui/icons/FavoriteBorder"
// eslint-disable-next-line
import UncheckedCircle from "@material-ui/icons/RadioButtonUnchecked"
// eslint-disable-next-line
import CheckedCircle from "@material-ui/icons/CheckCircleOutline"
// eslint-disable-next-line
import Card from "@material-ui/core/Card"
// eslint-disable-next-line
import Checkbox from "@material-ui/core/Checkbox"
import Fab from "@material-ui/core/Fab"
import DownIcon from "@material-ui/icons/KeyboardArrowDown"
import UpIcon from "@material-ui/icons/KeyboardArrowUp"
// eslint-disable-next-line
import HelpIcon from "@material-ui/icons/HelpOutline"
import grey from "@material-ui/core/colors/grey"
import Grid from '@material-ui/core/Grid';
//import useMediaQuery from '@material-ui/core/useMediaQuery';


// eslint-disable-next-line
import DashBarChart from "../Dash/A/DashBar2Chart.js"
//import DashMap from "../Dash/A/DashMapV4.js"
import DashMap from "../Dash/A/DashMapV6.js"
import DashTable from "../Dash/A/Dash3ColTable.js"
import DashGeoFilter from "../Dash/A/DashGeoFilter.js"


// UTILS
// eslint-disable-next-line
import * as _ from "lodash"
// eslint-disable-next-line
import * as moment from "moment"

// FLASH
// eslint-disable-next-line
import FlashTopBar from "../Flash/FlashTopBar.js"
import FlashHeader from "../Flash/FlashHeader.js"
// eslint-disable-next-line
import FlashSubHeader from "../Flash/FlashSubHeader.js"

// BL
import {
    // eslint-disable-next-line    
    maxNumberReducer,
    fieldFilter,
    getStateName,
    getSubGeoCodes,
//    calcTableDatasetMaxWeekOnly,
//    calcMapDatasetMaxWeekOnly,
    calcIssueTableDatasetTail,
    calcIssueMapDatasetTail,
    weighRanksByFbackCounts,
    // latest stuff
    // new-arch
    getIssueTrends
} from "../../bl/A/bl"

import {
    firstCross
} from "../Utils"

// GL
import gl from "../../gl.js"

// LogRocket
// import LogRocket from 'logrocket'


// LOGGING SETUP
import appConfig from "./../../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<IDash>")
//LogRocket.init('sbqpcc/flashdev')

const VARIATION = "A"

const styles = theme => ({
    
    //
    // GLOBAL STYLES START
    //
    separatorDiv: {
        ...theme.css.separatorDiv,
        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            width: theme.css.separatorDiv.desktop.width,
            height: theme.css.separatorDiv.desktop.height,
            marginTop: theme.css.separatorDiv.desktop.marginTop, // separate sections
            marginLeft: theme.css.separatorDiv.desktop.marginLeft,
            // borderRadius: theme.css.separatorDiv.desktop.borderRadius,
            // boxShadow: theme.css.separatorDiv.desktop.boxShadow,
            // borderTopLeftRadius: 6,
            // borderTopRightRadius: 6,
        },
    },

    checkedCircle: {
        ...theme.css.checkedCircle
    },

    uncheckedCircle: {
        ...theme.css.uncheckedCircle
    },
    //
    // GLOBAL STYLES END
    //
    
    continueButton: {
        margin: 20,
        padding: 8,
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        "&:hover": {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.light,
        },
    },

    contactList: {
        margin: 0,
        marginTop: 0,
        // tab from the left
        padding: "0px",
        // inside the container
        width: "100%",
    },

    contactItem: {
        // gap between cards (individual items)
        margin: 0,
        // cursor: "pointer",
        borderRadius: 0, // default 4
    },


    //
    // new stuff
    //
    mainDiv: {
        // mobile
        marginTop: 0,
        marginBottom: 0,
        marginLeft: "auto",
        marginRight: "auto",
        padding: 0,
        paddingTop: 90,


        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            paddingTop: 100,
	    // maxWidth: 1500, // this is different for dashboard
            // TODO: calculate this below
            maxWidth: 1250 // it's different for sahsboard vs. webapp
        },


        //
        // desktop - if more than 600
        //
        [theme.breakpoints.down("md")]: {
            paddingLeft: 0,
            paddingRight: 0
        },

        color: theme.palette.test.mainFG,
        background: theme.palette.test.mainBG,
    },

    

    mainDivFilter: {
        // mobile
        marginTop: 0,
        marginBottom: 0,
        marginLeft: "auto",
        marginRight: "auto",
        padding: 0,
        paddingTop: 90,

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            paddingTop: 100,
	    // maxWidth: 1500, // this is different for dashboard
            // TODO: calculate this below
            maxWidth: 1500 // it's different for sahsboard vs. webapp
        },

        color: theme.palette.test.mainFG,
        background: theme.palette.test.mainBG,
    },
    

    paperRoot: {
        // mobile
        margin: 0,
        maxWidth: "100%",
        padding: 10,
        paddingTop: 10,
        paddingBottom: 10,
        // maxHeight: 56,
        overflow: "hidden",
        cursor: "pointer",
        userSelect: "none",
        backgroundColor: "#FFFFFF",

        //
        // mobile
        //
        [theme.breakpoints.down("md")]: {
            marginBottom: 0,
            borderBottom: "1px solid",
            borderBottomColor: grey[200],
	    borderRadius: 0,
        },

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            marginTop: 15,
            borderRadius: 6,
        },
        
    },

    optionsPaperRoot: {
        // mobile
        margin: 0,
        maxWidth: "100%",
        // padding: 10,
        // paddingTop: 10,
        // paddingBottom: 10,
        // maxHeight: 56,
        overflow: "hidden",
        cursor: "pointer",
        userSelect: "none",
        backgroundColor: "#FFFFFF",

        //
        // mobile
        //
        [theme.breakpoints.down("md")]: {
            marginBottom: 0,
            borderBottom: "1px solid",
            borderBottomColor: grey[200],
	    borderRadius: 0,
        },

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            // marginTop: 15,
            // borderRadius: 6,
            borderRadius: 0,
        },
        
    },

    // SCROLL FAB
    fab: {
        position: "fixed",
        // bottom: theme.spacing(12),
        bottom: theme.spacing(2),
        // right: theme.spacing(1),
        // left: "45%", // middle
        left: "83%", // middle
        zIndex: 500,
        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            left: "75%",
        },
    },
    
    fabGreen: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.custom.scrollDark,
        '&:hover': {
            backgroundColor: theme.palette.custom.scrollLight,
        },
    },

    gridContainer: {
        // backgroundColor: "yellow",
        "&.MuiGrid-spacing-xs-2": {
            // backgroundColor: "red",
            "& .MuiGrid-item": { // this one *HAS* to have a space
                // no padding for items in mobile mode
                // backgroundColor: "blue",
                [theme.breakpoints.down("sm")]: {
                    backgroundColor: "green",
                    padding: 0
                },
            }
        }
    },

    jumpToButton: {
        marginLeft: "8px"
    },
    
})


const parseUrl = (location) => {

    const search = location.search; // could be '?foo=bar'
    const params = new URLSearchParams(search);

    let geo
    try {
        geo = JSON.parse(params.get('geo'))
        if(!geo) throw new Error("Error no geo in url")
        log.trace("parseUrl(): geo =", geo)
    } catch (error) {
        log.trace("parseUrl(): ERROR: could not decode url param geo in search.params =", search)
        geo = {
            level: "NATIONAL"
        }
    }
    
    return  {
        geo: geo
    }
}

class IDash extends Component {
    constructor(props) {
        super(props)

        // eslint-disable-next-line
        const { history, match, location } = this.props

        let { geo: parsedGeo } = parseUrl(location)
        log.debug("constructor(): parsedGeo = ", parsedGeo)

        //const geo = parsedGeo ? parsedGeo : { level: "NATIONAL" }

        let geo
        if(!parsedGeo || parsedGeo === null) {
            log.debug("constructor(): ONE parsedGeo = ", parsedGeo)
            geo = { level: "NATIONAL" }
        } else {
            log.debug("constructor(): TWO parsedGeo = ", parsedGeo)
            geo = parsedGeo
        }
        
        log.debug("constructor(): geo = ", geo)

        //let localDash = JSON.parse(localStorage.getItem("localDash"))
        const localDash = undefined

        gl.mapDataset = [] // this is a separate permanent dataset, differetn from this.state.mapDataset
//        gl.fullDataset = [] // this is a separate permanent dataset, for storing the data that does not
//                           // go directly to the map or table

        log.trace("constructor(): localDash: geo =", geo)

        // SOURCE
        const source  = {
            // like: "fback-sim"
            like: "fback%"
        }

        const isTooSmall = window.matchMedia('(max-width: 600px)').matches
        log.debug("constructor(): isTooSmall =", isTooSmall)
        
        this.state = {
            gl: null,
            variation: {
                  current: VARIATION,
                  A: "/idash/a",
                  B: "/idash/b",
            },
            isTrackingOpen: false,
            redirectBack: false,
            redirectToIDashUscd: false,
            redirectToSDash: false,
            redirectToSelf: false,
            scrollerDirection: "down",
            filters: [],
            rows: [],
            stats: [],
            dataset: [],
            highlights: [],
            geoCodes: [],
            localDash: localDash,
            showFilter: true,
            issueUUID: "",
            issueTrendDataset: [],
            statementTrendsDataset: [],
            // new stuff
            tableDataset: [],
            mapDataset: [],
            mapHighlights: [],
            mapZoomTarget: {},
            geoFilterDataset: [],
            geo: geo,
            source: source,
            isTooSmall: isTooSmall
        }
    }

    handleMapDoubleClick = (nextLevel, d, i) => {
        const { history } = this.props
        const { geo } = this.state

        //if(nextLevel === "whateverfornow") return

        log.debug("handleMapDoubleClick(): nextLevel = ", nextLevel)
        log.debug("handleMapDoubleClick(): d = ", d)

        /*
        const nationalGeo = {
            level: "NATIONAL"
        }
        */

        /*
        const stateGeo = {
            level: "STATE",
            stateCode: "CA"
        }
        */

        /*
        const uscdGeo = {
            level: "USCD",
            stateCode: "CA",
            uscdCode: "14"
        }
        */


        let nextGeo
        switch(geo.level) {
        case "NATIONAL":
            // go to state view
            nextGeo = {
                level: "STATE",
                stateCode: d.properties.code // code like "CA"
            }
            break
        case "STATE":
            nextGeo = {
                level: "USCD",
                stateCode: d.properties.flashStateCode, // code like "CA"
                uscdCode: d.properties.flashUscdCode // code like "01"
            }
            break
        case "SSD":
            this.handleGeoFilterRowClick({
                special: true,
                column1: {
                    val: d.properties.flashZipCode
                }
            })
        break
        case "USCD":
            this.handleGeoFilterRowClick({
                special: true,
                column1: {
                    val: d.properties.flashZipCode
                }
            })
           break
        default:
            log.error("handleMapDoubleClick(): ERROR: could not figure out geo = ", geo)
        }

        if(nextGeo) {
            history.push(`/idash?geo=${encodeURIComponent(JSON.stringify(nextGeo))}`)
            this.setState({redirectToSelf: true})
        }
    }


    // IS USED
    handleTableResult = (result) => {
        log.debug("handleTableResult(): SSDDATA: result.data.issueTrends =", result.data.issueTrends)
        
        //const calcs = calcTableDatasetMaxWeekOnly(result.data.issueTrends)
        const unweightedCalcs = calcIssueTableDatasetTail(result.data.issueTrends, 56)
        const weightedCalcs = weighRanksByFbackCounts(unweightedCalcs)

        //const calcs = unweightedCalcs
        const calcs = weightedCalcs

        
        log.debug("handleTableResult(): calcs =", calcs)

        const tableDataset = calcs.resultDataset.map(s => {
            return {
                // for DashTable
                column1: {
                    val: s.issue.txt,
                    uuid: s.issue.uuid,
                    slug: s.issue.slug
                },
	        
                column2: {
                    // val: s.AGG_ISSUE_FBACK_RANK_AVG
                    val: parseFloat((Math.round(s.AGG_ISSUE_FBACK_RANK_AVG * 100) / 100).toFixed(2))
                },

                column3: {
                    val: `${s.issue.level[0].toUpperCase()}${s.issue.level.slice(1)}`
                },

                name: s.issue.txt,
                col1: s.AGG_ISSUE_FBACK_COUNT,
                //col3: s.AGG_ISSUE_FBACK_PRO_COUNT,
                //col3: 0,
                // col3: 0.5,
                col3: s.AGG_ISSUE_FBACK_POSITIVE_RATIO_AVG,
                mark1: s.AGG_ISSUE_FBACK_LAST_WEEK_COUNT
                // col2: s.ISSUE_FBACK_COUNT/2, // do not display
                // col3: s.ISSUE_FBACK_PRO_COUNT,
                // col3: s.AGG_ISSUE_FBACK_PRO_COUNT,
                // col3: s.AGG_ISSUE_FBACK_COUNT / 2,
                // mark1: Math.floor((Math.random() * s.ISSUE_FBACK_COUNT) + 0)
            }
        })
        
        log.debug("handleTableResult(): tableDataset =", tableDataset)
        this.setState({tableDataset: tableDataset})
    }

    // IS USED
    // Runs for every area separately and adds new data to gl.mapDataset
    handleMapResult = (geo) => (result) => {
        log.debug("handleMapResult(): geo = ", geo)
        log.debug("handleMapResult(): result = ", result)


        // BUG: there is no 85534 code on the map, for not substitue it with 85535 that *is*
        // on the map
        if(geo.zipCode === "85534") geo.zipCode = "85533"

        // let mapDataset = calcMapDatasetMaxWeekOnly(result.data.issueTrends)
        // the whole year
        const calcs = calcIssueMapDatasetTail(result.data.issueTrends, 56)
        log.debug("handleMapResult(): calcs = ", calcs)
        // we're not really do it here yet 
        const mapDataset = calcs.resultDataset
        const issueFbackCount = calcs.resultIssueFbackCount

        log.debug("handleMapResult(): geo = ", geo)
        
        /*
        // NOTE: do we need this?
        // yes, we are using this for "handleTableRowHover"
        // to blick the pro/cons
        // does not seem to be helping with filter highlightning
        gl.fullDataset = [
            ...gl.fullDataset,
            ...mapDataset.map(d => {
                return {
                    geo: geo,
                    ...d
                }
            })
        ]
*/

        // GEO_SPECIFIC
        // areaDataset is a dataset for a speciic area (state, uscd, etc.)
        // so we need to mark it specially here
        // this would be ran for each one
        let areaData

        switch (geo.level) {
        case "ZIP":
            areaData = {
                geo: geo, // identifies which data level it is, STATE, USCD, ZIP
                FBACK_COUNT: issueFbackCount,
                user: {
                    geo: {
                        state: {
                            code: geo.stateCode // we need this to id the location
                        },
                        uscd: {
                            code: geo.uscdCode
                        },
                        zip: {
                            code: geo.zipCode,
                            // plus4: "4224",
                        }
                    }
                }
            }
            break;
        case "USCD":
            areaData = {
                geo: geo, // identifies which data level it is, STATE, USCD, ZIP
                FBACK_COUNT: issueFbackCount,
                user: {
                    geo: {
                        state: {
                            code: geo.stateCode // we need this to id the location
                        },
                        uscd: {
                            code: geo.uscdCode
                        }
                    }
                }
            }
            break;
        case "STATE":
            areaData = {
                geo: geo, // identifies which data level it is, STATE, USCD, ZIP
                FBACK_COUNT: issueFbackCount,
                user: {
                    geo: {
                        state: {
                            code: geo.stateCode // we need this to id the location
                        },
                    }
                }
            }
            break;
        case "SSD":
            areaData = {
                geo: geo, // identifies which data level it is, STATE, USCD, ZIP
                FBACK_COUNT: issueFbackCount,
                user: {
                    geo: {
                        state: {
                            code: geo.stateCode // we need this to id the location
                        },
                        ssd: {
                            code: geo.ssdCode
                        },
                        uscd: {
                            code: geo.uscdCode
                        },
                        zip: {
                            code: geo.zipCode,
                        }
                    }
                }
            }
            break;
        default:
        }

        log.debug("handleMapResult(): areaData = ", areaData)
        // NEXT: go down below and see what's up


        const newMapDataset = [
            ...this.state.mapDataset,
            areaData
        ]

        log.debug("handleMapResult(): newMapDataset = ", newMapDataset)
        

        // NOTE: do we need this?
        // yes, we are using this for "handleTableRowHover"
        // to blick the pro/cons
        // does not seem to be helping with filter highlightning
        /*
        gl.fullDataset = [
            ...gl.fullDataset,
            ...mapDataset.map(d => {
                return {
                    geo: geo,
                    ...d
                }
            })
        ]
        */
        
        // merge already existing dataset with this map dataset
        this.setState({dataset: [
            ...this.state.dataset,
            ...mapDataset.map(d => {
                return {
                    geo: geo,
                    ...d
                }
            })
        ]})
        
        
        // to update the filter
        // there are 2 places where we're calling out
        // the updateGeoFilterDataset
        // because sometimes not all the data
        // is there yet as it's loading dynamically
        this.updateGeoFilterDataset([
                ...this.state.mapDataset,
                areaData
        ], undefined)

        log.debug("handleMapResult(): newMapDataset = ", newMapDataset)
        this.setState({mapDataset: newMapDataset})
        
        /*
        this.setState({
            mapDataset: [
                ...this.state.mapDataset,
                areaData
            ]
        })
        */
    }

    // IS USED
    handleTableError = (error) => {
        log.debug("handleTableError(): error = ", JSON.stringify(error,null," "))
    }
    
    // IS USED
    handleMapError = geo => error => {
        log.trace("handleTableError(): error = ", JSON.stringify(error,null," "))
    }

    
    // we get map properties in a separate
    // place, beofre mapDataset is available
    // merge the 2 here
    // this.setState({geoFilterDataset: geoFilterDataset}) is in
    // handleGeoFilterMapProperties()
    updateGeoFilterDataset = (_mapDataset, _geoFilterDataset) => {
        // continue here, do the merging here also
        // similar to handleGeoFilterMapProperties
        const mapDataset = _mapDataset ? _mapDataset : this.state.mapDataset
        const geoFilterDataset = _geoFilterDataset ? _geoFilterDataset : this.state.geoFilterDataset
            
        const geo = this.state.geo
        log.trace("updateGeoFilterDataset(): geo = ", geo)
        log.trace("updateGeoFilterDataset(): mapDataset =", mapDataset)
        log.trace("updateGeoFilterDataset(): geoFilterDataset =", geoFilterDataset)
	// just do the same thing here as in handleGeoFilterMapProperties for now
        let showCount = 0
        let showMax = 10

        const updatedGeoFilterDataset = geoFilterDataset.map(p => {

	    let isFound = false

            switch(geo.level) {
            case "NATIONAL":
                log.trace("updateGeoFilterDataset(): FIND: NATIONAL, p = ", p)
                mapDataset.forEach(m => {
                    log.trace("updateGeoFilterDataset(): FIND: m.geo.stateCode = ", m.geo.stateCode)
                    if(m.FBACK_COUNT && m.geo.stateCode === p.column1.val) {
                        isFound = true
		    }
		})
                break;
            case "STATE":
                log.trace("updateGeoFilterDataset(): FIND: STATE: p = ", p)
                mapDataset.forEach(m => {
                    log.trace("updateGeoFilterDataset(): FIND: STATE: m = ", m)
                    const name = `${m.geo.stateCode}-${m.geo.uscdCode}`
                    log.trace("updateGeoFilterDataset(): FIND: STATE: name = ", name)
                    log.trace("updateGeoFilterDataset(): FIND: STATE: p.column1.name = ", p.column1.name)
                    // if(m.geo.uscdCode === p.column1.val) {
                    if(m.FBACK_COUNT && `${m.geo.stateCode}-${m.geo.uscdCode}` === p.column1.name) {
                        isFound = true
                        log.trace("updateGeoFilterDataset(): FIND: FOUND: STATE: name = ", name)
                        log.trace("updateGeoFilterDataset(): FIND: FOUND: STATE: p.column1.name = ", p.column1.name)
                        log.trace("updateGeoFilterDataset(): FIND: FOUND: STATE: FOUND = ", isFound)
		    }
		})
                break;
            case "SSD":
                if(showCount++ < showMax) {
                    log.trace("updateGeoFilterDataset(): FIND: SSD: p = ", p)
                }
                    
                //log.debug("updateGeoFilterDataset(): FIND: SSD: p = ", p)
                /*
                mapDataset.forEach(m => {
                    log.trace("updateGeoFilterDataset(): FIND: SSD: m = ", m)
                    const name = `${m.geo.stateCode}-${m.geo.uscdCode}`
                    log.trace("updateGeoFilterDataset(): FIND: SSD: name = ", name)
                    log.trace("updateGeoFilterDataset(): FIND: SSD: p.column1.name = ", p.column1.name)
                    // if(m.geo.uscdCode === p.column1.val) {
                    if(m.FBACK_COUNT && `${m.geo.stateCode}-${m.geo.uscdCode}` === p.column1.name) {
                        isFound = true
                        log.trace("updateGeoFilterDataset(): FIND: FOUND: SSD: name = ", name)
                        log.trace("updateGeoFilterDataset(): FIND: FOUND: SSD: p.column1.name = ", p.column1.name)
                        log.trace("updateGeoFilterDataset(): FIND: FOUND: SSD: FOUND = ", isFound)
		    }
		})
                */
                break;
            case "USCD":
                log.trace("updateGeoFilterDataset(): FIND: USCD, p = ", p)
                mapDataset.forEach(m => {
                    log.trace("updateGeoFilterDataset(): FIND: USCD, m = ", m)
                    if(m.FBACK_COUNT && m.geo.zipCode === p.column1.val) {
                        isFound = true
		    }
		})
                break;
            default:
                break;
            }

            if(isFound) {
		log.trace("updateGeoFilterDataset(): FIND: FOUND: p = ", p)
                p.column1.color = "#4a4a4a"
                p.column1.fontSize = "16px"
            }

            return p
        })

        if(geo.level === "SSD") {
            this.setState({geoFilterDataset: [
                {column1: {name: "CA-SD-13", val: "13", color: "#4a4a4a", fontSize: "16px"}},
                {column1: {name: "CA-SD-15", val: "15",
                           //                           color: "#4a4a4a", fontSize: "16px"
                          }},
                {column1: {name: "CA-SD-Other", val: "00"}},
            ]})
        } else {
            this.setState({geoFilterDataset: updatedGeoFilterDataset})
        }
    }

    
    fetchData = async (geo) => {
        // GEO_SPECIFIC
        
        log.trace("fetchData(): geo = ", geo)

        const source = this.state.source
        log.trace("fetchData(): source = ", source)
        
        let filters
        let subGeoLevel
        let tableGeoLevel
        if(geo.level === "USCD") {
            tableGeoLevel = geo.level
            subGeoLevel = "ZIP"
            filters = {
                sourceLike: source.like,
                stateCode: geo.stateCode,
                uscdCode: geo.uscdCode
            }
        } else if(geo.level === "STATE") {
            tableGeoLevel = geo.level
            subGeoLevel = "USCD"
            filters = {
                sourceLike: source.like,
                stateCode: geo.stateCode,
            }
        } else if(geo.level === "SSD") {
            //geo.level = "STATE" // SSD_DEBUG still pull data at the state level
            tableGeoLevel = "STATE"
            subGeoLevel = "ZIP"
            filters = {
                sourceLike: source.like,
                stateCode: geo.stateCode,
            }
        } else if(geo.level === "NATIONAL") {
            tableGeoLevel = geo.level
            subGeoLevel = "STATE"
            filters = {
                sourceLike: source.like,
            }
        }

        log.debug("fetchData(): VIEWFIX: table geo.level = ", geo)
        log.debug("fetchData(): VIEWFIX: table tableGeoLevel = ", tableGeoLevel)
        log.debug("fetchData(): VIEWFIX: table filters = ", filters)

        // TABLE
        /*
        getIssueTrends(geo.level, "NA", {
            onResult: this.handleTableResult,
            onError: this.handleTableError
        }, filters)
        */

        getIssueTrends(tableGeoLevel, "NA", {
            onResult: this.handleTableResult,
            onError: this.handleTableError
        }, filters)

        //DEBUG -- just get the table issues
        // return

        //
        // MAP
        //
        // GEO_SPECIFIC
        //

        //
        // MAP SUBGEOS
        //
        log.debug("fetchData(): SUBGEOS")
        const subGeoCodes = await getSubGeoCodes(geo)

        log.debug("fetchData(): STICKYFIX: subGeoCodes = ", subGeoCodes)

        if(!subGeoCodes || subGeoCodes.length === 0) return
        
        subGeoCodes.forEach(code => {
            let geoFilter
            let subGeo
            let filters
            if(subGeoLevel === "ZIP") {
                geoFilter = {
                    zipCode: code
                }
            } else if(subGeoLevel === "USCD") {
                subGeo = {
                    level: subGeoLevel,
                    stateCode: geo.stateCode,
                    uscdCode: code,
                }
                filters = {
                    sourceLike: source.like,
                    stateCode: subGeo.stateCode,
                    uscdCode: subGeo.uscdCode,
                }
            } else if(subGeoLevel === "STATE") {
                subGeo = {
                    level: subGeoLevel,
                    stateCode: code,
                }
                filters = {
                    sourceLike: source.like,
                    stateCode: code,
                }
            } else if(subGeoLevel === "SSD") {
                subGeo = {
                    level: subGeoLevel,
                    stateCode: code,
                }
                filters = {
                    sourceLike: source.like,
                    stateCode: code,
                }
            }


            if(!subGeo) {
                filters = {
                    sourceLike: source.like,
                    ...geoFilter
                }
                subGeo = {
                    level: subGeoLevel,
                    ...geoFilter
                }
            }


            log.debug("fetchData(): STICKYFIX: calling getIssueTrends() with subGeoLevel = ", subGeoLevel)
            log.debug("fetchData(): STICKYFIX: calling getIssueTrends() with subGeo = ", subGeo)
            log.debug("fetchData(): STICKYFIX: calling getIssueTrends() with filters = ", filters)
            
            getIssueTrends(subGeoLevel, "NA", {
                onResult: this.handleMapResult(subGeo),
                onError: this.handleMapError(subGeo)
            }, filters)
            
        })


    }

    
    componentDidUpdate = () => {
        log.trace("componentDidUpdate()")
        const { location } = this.props
        const {geo: parsedGeo} = parseUrl(location)
        
        if(this.state.redirectToSelf === true) {
            log.debug("componentDidUpdate(): was redriectToSelf")
            this.setState({
                redirectToSelf: false,
            })
        }

        if(parsedGeo && JSON.stringify(this.state.geo) !== JSON.stringify(parsedGeo)) {
            log.debug("componentDidUpdate(): VIEWFIX: geo has changed: parsedGeo =", parsedGeo)
            log.debug("componentDidUpdate(): VIEWFIX: geo has changed: this.state.geo =", this.state.geo)
            this.fetchData(parsedGeo) // geo has changed
            this.setState({
                geo: parsedGeo,
                redirectToSelf: true,
            })
        }
    }


    componentDidMount = () => {

        document.title = 'PulseAI Dashboard';
        
        window.addEventListener("scroll", this.handleScroll);
        if(this.headDivEl) this.scrollToTop()
        document.querySelector("body").style.overflowY = "scroll" // aways how scrollbar

        log.debug("componentDidMount(): this.state.geo = ", this.state.geo)

        this.fetchData(this.state.geo)
    }
    
    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll)
    }

    handleScroll = (event) => {
        if(!this.state.scrollerDirection) {
            this.setState({scrollerDirection: "down"})
            return
        }

        const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
        const body = document.body;
        const html = document.documentElement;
        const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight,  html.scrollHeight, html.offsetHeight);
        const windowBottom = windowHeight + window.pageYOffset;

        log.trace("handleScroll(): window.pageYOffset =", window.pageYOffset)

        if (windowBottom >= (docHeight - 1)) {
            this.setState({scrollerDirection: "up"})
        } else if(window.pageYOffset === 0) {
            this.setState({scrollerDirection: "down"})
        }
    }

    scrollToBottom = () => {
        log.trace("scrollToBottom(): this.contentDivEl = ", this.contentDivEl)
        log.trace("scrollToBottom(): this.tailDivEl = ", this.tailDivEl)
        
        this.tailDivEl.scrollIntoView({
            behavior: "smooth",
            block: "start",
        })
    }

    scrollToTop = () => {
        log.trace("scrollToBottom(): this.headDivEl = ", this.headDivEl)
        log.trace("scrollToBottom(): this.tailDivEl = ", this.tailDivEl)
        
        this.headDivEl.scrollIntoView({
            behavior: "smooth",
            block: "start",
        })
    }


    handleMapFilterClick = () => {
        log.trace("handleMapFilterClick()")
        this.setState({showFilter: !this.state.showFilter})
    }


    enrichTrendDataDesc = (data) => {
        let prevValue
        let flashItemNumber = 1
        let flashItemDirection
        let flashItemType
        let itemLastNumber = data.length
        
        const enrichedData = data
	      .sort((a,b) => {
	          const am = moment(a.timestamp)
	          const bm = moment(b.timestamp)
	          return am.diff(bm)
	      })    
	      .map(d => {
	          if(flashItemNumber === itemLastNumber) {
		      flashItemType = "current"
	          } else if(flashItemNumber === (itemLastNumber - 1)) {
		      flashItemType = "lastWeek"
	          } else {
                      flashItemType = undefined
                  }
	          if(prevValue) {
		      if(prevValue < d.value) {
		          flashItemDirection = "up"
		      } else if(prevValue > d.value) {
		          flashItemDirection = "down"
		      } else {
		          flashItemDirection = "same"
		      }
	          }
	          prevValue = d.value
	          return {
		      ...d,
		      flashValue: d.value,
		      flashTimestamp: moment(d.timestamp).toDate(),
		      flashItemNumber: flashItemNumber++,
		      flashItemType: flashItemType,
		      flashItemDirection: flashItemDirection
	          }
	      })
        return enrichedData
    }
    
    handleTableRowClick = (row, event) => {

        const { history } = this.props
        const { geo, tableGeo } = this.state
        
        log.debug("handleTableRowClick(): SSDDATA: geo =", geo)
        log.debug("handleTableRowClick(): SSDDATA: tableGeo =", tableGeo)

        let newGeo
        if(tableGeo) {
            // we're on the sublevel, for example we've clicked the specific SSD in the ssd view
            newGeo = tableGeo
        } else {
            // if we're at the top level and we're in a "split level" like SSD
            // our "top" level for the issue in the table is actually
            // STATE, not SSD
            if(geo.level === "SSD") {
                newGeo = {
                    ...geo,
                    level: "STATE"
                }
            } else {
                newGeo = geo
            }
        }

        
        log.debug("handleTableRowClick(): SSDDATA: row =", row)
        log.trace("handleTableRowClick(): event =", event)
        log.trace("handleTableRowClick(): this.state.mapDataset =", this.state.mapDataset)
        log.trace("handleTableRowClick(): gl.fullDataset =", gl.fullDataset)
        log.trace("handleTableRowClick(): this.state.geo =", this.state.geo)


        log.trace("constructor(): localDash before =", this.state.localDash)
        // this should be localDash.issueDetailView.{issue: txt, issue.uuid}
        const localDash = {
            ...this.state.localDash,
            issueDetailView: {
                //                geo: this.state.geo,
                geo: newGeo,
                issue: {
                    uuid: row.column1.uuid,
                    slug: row.column1.slug,
                    txt: row.column1.val,
                }
            }
        }

        log.trace("constructor(): localDash after =", localDash)

        // localStorage.setItem("localDash", JSON.stringify(localDash))

        // direct link
        const nextGeo = newGeo
        const nextIssue = {
            slug: row.column1.slug,
            txt: row.column1.val
        }
        
        // redirect to sdash
        history.push(`/sdash?geo=${encodeURIComponent(JSON.stringify(nextGeo))}&issue=${encodeURIComponent(JSON.stringify(nextIssue))}`)
        this.setState({redirectToSDash: true})
        
    }


    handleGeoFilterRowHover = row => {
        log.trace("handleGeoFilterRowHover(): row =", row)

        const { mapHighlights: oldHighlights } = this.state

        // GEO_SPECIFIC
        let newHighlights
        const geo = this.state.geo
        if(geo.level === "USCD") {
            newHighlights = [{
                stateCode: geo.stateCode,
                uscdCode:  geo.uscdCode,
                zipCode:  row.column1.val,
                // color: "#ffeb3b" // nice yellow
                // color: "#795548a8" // cool brown
                fill: true
            }]
        } else if(geo.level === "STATE") {
            newHighlights = [{
                stateCode: this.state.geo.stateCode,
                uscdCode:  row.column1.val,
                // color: "#795548a8" // cool brown
                fill: true
            }]
        } else if(geo.level === "SSD") {
            newHighlights = [{
                stateCode: this.state.geo.stateCode,
                //uscdCode:  row.column1.val,
                ssdCode:  row.column1.val,
                // color: "#795548a8" // cool brown
                fill: true
            }]
        } else if(geo.level === "NATIONAL") {
            newHighlights = [{
                stateCode: row.column1.val,
                fill: true
            }]
        }

        log.trace("handleGeoFilterRowHover(): STICKY: 1: oldHighlights =", oldHighlights)
        log.trace("handleGeoFilterRowHover(): STICKY: 2: newHighlights =", newHighlights)

        const mergedHighlights = [
            ...oldHighlights.filter(h => h.sticky),
            ...newHighlights
        ]

        const finalHighlights = mergedHighlights
              .map(h => { h.source = "geo-filter-row-hover"; return h })
        
        this.setState({
            mapHighlights: finalHighlights
        })

    }

    handleGeoFilterRowUnhover = row => {
        //log.debug("handleGeoFilterRowUnhover(): row =", row)
        
        /*
        if(this.state.geo.level === "SSD") {
            // return only if
            
            }
        */

        const finalHighlights = this.state.mapHighlights
              .filter(h => h.sticky)
              .map(h => { h.source = "geo-filter-row-unhover"; return h })
        //const highlights = []
        log.trace("handleGeoFilterRowUnhover(): STICKY: finalHighlights =", finalHighlights)
        this.setState({
            mapHighlights: finalHighlights
        })

    }

    handleGeoFilterMapProperties = properties => {
        log.debug("handleGeoFilterMapProperties(): properties =", properties)
        log.debug("handleGeoFilterMapProperties(): this.state.mapDataset =", this.state.mapDataset)
        // log.trace("handleGeoFilterMapProperties(): gl.fullDataset =", gl.fullDataset)

        // NO_DATA
        // if(!properties || properties.length === 0) return
        
        // GEO_SPECIFIC
        const geo = this.state.geo
        const geoFilterDataset = properties.map(p => {
            let backgroundColor
            if(geo.level === "USCD") {
                return {
                    column1: {
                        val: p.flashZipCode,
                        backgroundColor: backgroundColor
                    }
                }
            } else if(geo.level === "STATE") {
                return {
                    column1: {
                        name: `${p.flashStateCode}-${p.flashUscdCode}`,
                        val: p.flashUscdCode,
                        backgroundColor: backgroundColor
                    }
                }
            } else if(geo.level === "SSD") {
                return {
                    column1: {
                        name: `${p.flashStateCode}-${p.flashUscdCode}`,
                        val: p.flashUscdCode,
                        backgroundColor: backgroundColor
                    }
                }
            } else if(geo.level === "NATIONAL") {
                log.trace("handleGeoFilterMapProperties(): setting data with p =", p)
                return {
                    column1: {
                        name: `${p.name}`,
                        val: p.code,
			backgroundColor: backgroundColor
                    }
                }
            } else {
                return {
                    column1: {
                        val: "Unknown", //p.flashZipCode,
                        backgroundColor: backgroundColor
                    }
                }
            }
        }).sort((a,b) => {
            return a.column1.val > b.column1.val ? 1 : -1
	})

        log.debug("handleGeoFilterMapProperties(): geoFilterDataset =", geoFilterDataset)

        this.updateGeoFilterDataset(undefined, geoFilterDataset)
    }
    
    handleGeoFilterRowClick = row => {
        log.debug("handleGeoFilterRowClick(): row =", row)
        log.debug("handleGeoFilterRowClick(): this.state.geoFilterDataset =", this.state.geoFilterDataset)
        const geo = this.state.geo
        
        // GEO_SPECIFIC
        let subGeo
        if(row.special) {
            subGeo = {
                ...this.state.geo,
                level: "ZIP",
                zipCode: row.column1.val
            }
        } else if(geo.level === "USCD") {
            subGeo = {
                ...this.state.geo,
                level: "ZIP",
                zipCode: row.column1.val
            }
        } else if (geo.level === "STATE") {
            subGeo = {
                ...this.state.geo,
                level: "STATE",
                uscdCode: row.column1.val
            }
        } else if (geo.level === "SSD") {
            log.debug("handleGeoFilterRowClick(): I'm in SSD")
            subGeo = {
                ...this.state.geo,
                level: "SSD",
                ssdCode: row.column1.val
                //uscdCode: row.column1.val
            }
        } else if (geo.level === "NATIONAL") {
            subGeo = {
                ...this.state.geo,
                level: "NATIONAL",
                stateCode: row.column1.val
            }
        }


        // here we ahve to have this:
        // p.column1.backgroundColor = "#4a4a4a"
        // p.column1.fontSize = "15px"

        const geoFilterDataset = this.state.geoFilterDataset.map(p => {
            if(p.column1.val === row.column1.val) {
                p.column1.backgroundColor = "#f2f2f2"
                // p.column1.backgroundColor = "#448cffc9"
                // p.column1.color = "black"
                // p.column1.color = "#4a4a4a"
                // p.column1.fontSize = "15px"
            } else {
                delete p.column1.backgroundColor
                // p.column1.backgroundColor = undefined
            }

            return p
        })

        if(subGeo) {
            log.debug("handleGeoFilterRowClick(): SSDDATA: subGeo =", subGeo)
            /*
              BL:debug getIssueTrends(): SSDDATA: geoLevel = +0ms STATE
              browser.js:181 BL:debug getIssueTrends(): SSDDATA: aggLevel = +0ms NA
              browser.js:181 BL:debug getIssueTrends(): SSDDATA: filters = +0ms {sourceLike: "fback%", stateCode: "CA"}
            */

            const tableGeoLevel = subGeo.level
            let filters = {
                sourceLike: "fback%",
//                stateCode: subGeo.stateCode,
//                ssdCode: subGeo.ssdCode
            }

            if(subGeo.level === "ZIP") {
                filters = {
                    ...filters,
                    zipCode: subGeo.zipCode
                }
            } else if(subGeo.level === "SSD") {
                filters = {
                    stateCode: subGeo.stateCode,
                    ssdCode: subGeo.ssdCode
                }
            } else if(subGeo.level === "STATE") {
                filters = {
                    stateCode: subGeo.stateCode,
                    uscdCode: subGeo.uscdCode
                }
            }

            
            getIssueTrends(tableGeoLevel, "NA", {
                onResult: this.handleTableResult,
                onError: this.handleTableError
            }, filters)


        }
        

        if(subGeo) {

            // the subGeo is something that we just clicked on
            // we can reset the highlights and just add this one with a sticky
            // this will overwrite all the highlights,
            // first reset
            const newHighlights = [{...subGeo, fill: true, sticky: true}]
            log.debug("handleGeoFilterRowClick(): STICKYL: newHighlights =", newHighlights)
            const finalMapHighlights = 
                  newHighlights.map(h => { h.source = "geo-filter-row-click"; return h })
            
            this.setState({
                geoFilterDataset: geoFilterDataset,
                mapZoomTarget: subGeo,
                mapHighlights: newHighlights,
                tableGeo: subGeo
            })
        }
    }

/*
    handleTableChartHover_old = chartObj => {
       log.trace("handleTableChartHover(): chartObj =", chartObj)

        const issueUUID = chartObj.column1.uuid

        log.trace("handleTableChartHover(): issueUUID =", issueUUID)

        const dataset = gl.fullDataset

        if(!dataset || dataset.length === 0) return

        //
        // this below, will be calculating the true ranking in that particular state
        //
        
        const thisIssueDataset = dataset.filter(fieldFilter("issue.uuid", issueUUID))
        log.trace("handleTableChartHover(): thisIssueDataset =", thisIssueDataset)

        //        const maxWeek = thisIssueDataset.reduce(maxNumberReducer("WEEK_N"))
        //        log.trace("handleTableChartHover(): maxWeek =", maxWeek)

        // CALC
        let maxWeekNumber = 0
        thisIssueDataset.forEach(d => {
            if(d["WEEK_N"] >= maxWeekNumber) {
                maxWeekNumber = d["WEEK_N"]
            }
        })

        log.trace("handleTableChartHover(): maxWeekNumber =", maxWeekNumber)
        const maxWeekDataset = thisIssueDataset.filter(fieldFilter("WEEK_N", maxWeekNumber))
        log.trace("handleTableChartHover(): maxWeekDataset =", maxWeekDataset)

        
        if(thisIssueDataset !== []) {
            const highlights = maxWeekDataset.map(s => {

                log.trace("handleTableChartHover(): s =", s)

                //let proRatio
                //proRatio = s.ISSUE_FBACK_PRO_COUNT / s.ISSUE_FBACK_COUNT
                let proRatio = s.ISSUE_FBACK_POSITIVE_RATIO
                log.trace("handleTableChartHover(): proRatio =", proRatio)

                let highlightColor
                if(proRatio >= 0.5) {
                    // highlightColor = "green"
                    highlightColor = "#7db47b"
                } else {
                    // highlightColor = "yellow"
                    highlightColor = "#ffeb3b" // yellow
                }

                //highlightColor = "black"
                // GEO_SPECIFIC - maybe?
                return {
                    stateCode: s.geo.stateCode,
                    uscdCode:  s.geo.uscdCode,
                    zipCode:  s.geo.zipCode,
                    color: highlightColor
                    // fillValue: s.ISSUE_FBACK_COUNT
                }
            })
            this.setState({
                mapHighlights: highlights
            })
        }
    }
*/

    handleTableChartHover = chartObj => {
        log.trace("handleTableChartHover(): chartObj =", chartObj)

        const issueUUID = chartObj.column1.uuid

        log.trace("handleTableChartHover(): issueUUID =", issueUUID)

        //const dataset = gl.fullDataset
        const { dataset } = this.state

        if(!dataset || dataset.length === 0) return

        //
        // this below, will be calculating the true ranking in that particular state
        //
        
        const thisIssueDataset = dataset.filter(fieldFilter("issue.uuid", issueUUID))
        log.trace("handleTableChartHover(): thisIssueDataset =", thisIssueDataset)

        //        const maxWeek = thisIssueDataset.reduce(maxNumberReducer("WEEK_N"))
        //        log.trace("handleTableChartHover(): maxWeek =", maxWeek)

        // CALC
        let maxWeekNumber = 0
        thisIssueDataset.forEach(d => {
            if(d["WEEK_N"] >= maxWeekNumber) {
                maxWeekNumber = d["WEEK_N"]
            }
        })

        log.trace("handleTableChartHover(): maxWeekNumber =", maxWeekNumber)
        const maxWeekDataset = thisIssueDataset.filter(fieldFilter("WEEK_N", maxWeekNumber))
        log.trace("handleTableChartHover(): maxWeekDataset =", maxWeekDataset)

        
        if(thisIssueDataset !== []) {
            const newHighlights = maxWeekDataset.map(s => {

                log.trace("handleTableChartHover(): s =", s)

                //let proRatio
                //proRatio = s.ISSUE_FBACK_PRO_COUNT / s.ISSUE_FBACK_COUNT
                let proRatio = s.ISSUE_FBACK_POSITIVE_RATIO
                log.trace("handleTableChartHover(): proRatio =", proRatio)

                let highlightColor
                if(proRatio >= 0.5) {
                    // highlightColor = "green"
                    highlightColor = "#7db47b"
                } else {
                    // highlightColor = "yellow"
                    highlightColor = "#ffeb3b" // yellow
                }

                //highlightColor = "black"
                // GEO_SPECIFIC - maybe?


                let highlight = {
                    stateCode: s.geo.stateCode,
                    uscdCode:  s.geo.uscdCode,
                    zipCode:  s.geo.zipCode,
                    color: highlightColor,
                    // fillValue: s.ISSUE_FBACK_COUNT
                    "exclusive": true,
                    level: "default"
                }


                if(this.state.geo.level === "SSD") {
                    highlight.level = "ZIP"
                }

                
                return highlight
            })

            const { mapHighlights: oldHighlights } = this.state
            
            log.trace("handleTableChartHover(): 1: oldHighlights =", oldHighlights)
            log.trace("handleTableChartHover(): 2: newHighlights =", newHighlights)

            const mergedHighlights = [
                ...oldHighlights.filter(h => h.sticky),
                ...newHighlights
            ]

            log.trace("handleTableChartHover(): 3: mergedHighlights =", mergedHighlights)

            const finalHighlights = mergedHighlights
                  .map(h => { h.source = "issue-table-chart-hover"; return h })

            this.setState({
                mapHighlights: finalHighlights
            })
        }
    }
    

    handleTableRowHover = row => {
        
        // tableDataset - each is a row in the table with a total count and issue anme
        // dataset - the dataset that has all the metrics, and the down to the zipCode numbers
        // geo - is the geo of this view
        const { geo, tableDataset, dataset } = this.state
        log.debug("handleTableRowHover(): STICKYFIX: geo =", geo)
        log.debug("handleTableRowHover(): STICKYFIX: tableDataset =", tableDataset)
        log.debug("handleTableRowHover(): STICKYFIX: dataset =", dataset)
        log.debug("handleTableRowHover(): STICKYFIX: row =", row)

        const selectedIssueSlug = row.column1.slug
        log.debug("handleTableRowHover(): STICKYFIX: selectedIssueSlug =", selectedIssueSlug)

        const selectedIssueDataset = dataset.filter(d => d.issue.slug === selectedIssueSlug )

        log.debug("handleTableRowHover(): STICKYFIX: selecteIssueDataset =", selectedIssueDataset)
        
        const maxWeek = selectedIssueDataset.reduce((acc, curr) => {
            // console.log("acc =", acc)
            if(curr.YEAR_N >= acc.YEAR_N) {
	        const newAcc = {
	            YEAR_N: curr.YEAR_N
	        }
	        if(curr.WEEK_N >= acc.WEEK_N) {
	            newAcc.WEEK_N = curr.WEEK_N
	        } else {
	            newAcc.WEEK_N = acc.WEEK_N
	        }
	        return newAcc
            }
            return acc
        }, {YEAR_N: 0, WEEK_N: 0})


        log.debug("handleTableRowHover(): STICKYFIX: maxWeek =", maxWeek)
        const maxWeekDataset = selectedIssueDataset.filter(d => d.YEAR_N === maxWeek.YEAR_N && d.WEEK_N === maxWeek.WEEK_N)
        const allWeekDataset = selectedIssueDataset

        log.debug("handleTableRowHover(): STICKYFIX: maxWeekDataset =", maxWeekDataset)

        const highlightDataset = maxWeekDataset
        if(highlightDataset === []) return

        log.debug("handleTableRowHover(): STICKYFIX: highlightDataset =", highlightDataset)

        const newHighlights = highlightDataset.map(d => {
            let newGeoLevel
            return {
                "level": d.geo.level,
                "zipCode":  d.geo.zipCode,
                //                "fillValue": d.ISSUE_FBACK_COUNT,
                "fillValue": d.ISSUE_FBACK_COUNT * 10, // TODO: do this fill value better
                "sticky": false,
                "exclusive": true,
                "source": "geo-table-row-hover"
            }
        })


        // NEXT: calculate the table hover, how much feedback to we have from a parciular issue
        // for each zip code, and highlight that zip code

        /*
        const newHighlights = [
            {
                "level": "ZIP",
                "stateCode": "CA",
                "ssdCode": "13",
                "zipCode":  "94010",
                "fillValue": 10,
                "sticky": false,
                "source": "geo-table-row-hover"
            }
        ]
        */

        const { mapHighlights: oldHighlights } = this.state

        const mergedHighlights = [
            ...oldHighlights.filter(h => h.sticky),
            ...newHighlights
        ]

        log.debug("handleTableRowHover(): STICKYFIX: mergedHighlights =", mergedHighlights)

        const finalHighlights = mergedHighlights
              .map(h => { h.source = "issue-table-row-hover"; return h })
        
        this.setState({
            mapHighlights: finalHighlights
        })
    }


/*
    handleTableRowHover_old = row => {
        log.debug("handleTableRowHover(): STICKYROW: this.state.geo =", this.state.geo)
        log.debug("handleTableRowHover(): STICKYROW: row =", row)
        log.debug("handleTableRowHover(): tableDataset =", this.state.tableDataset)
        
        // NEXT: full dataset should have ssd field
        const dataset = gl.fullDataset

        if(!dataset || dataset.length === 0) return

        const tableLevelProRatio = row.col3 / row.col1
        //const tableLevelProRatio = row.col3
        log.debug("handleTableRowHover(): tableLevelProRatio =", tableLevelProRatio)

        //
        // this below, will be calculating the true ranking in that particular state
        //
        
        const thisIssueDataset = dataset.filter(fieldFilter("issue.uuid", row.column1.uuid))
        log.debug("handleTableRowHover(): thisIssueDataset =", thisIssueDataset)

        //const maxWeek = thisIssueDataset.reduce(maxNumberReducer("WEEK_N"))
        //log.trace("handleTableRowHover(): maxWeek =", maxWeek)

        let maxWeekNumber = 0
        thisIssueDataset.forEach(d => {
            if(d["WEEK_N"] >= maxWeekNumber) {
                maxWeekNumber = d["WEEK_N"]
            }
        })
        
        const maxWeekDataset = thisIssueDataset.filter(fieldFilter("WEEK_N", maxWeekNumber))
        log.trace("handleTableRowHover(): maxWeekDataset =", maxWeekDataset)

        if(thisIssueDataset !== []) {
            const newHighlights = maxWeekDataset.map(s => {

                log.trace("handleTableRowHover(): s =", s)

                //let highlightColor
                //highlightColor = "black"

                // GEO_SPECIFIC - maybe?

                let highlight = {
                    stateCode: s.geo.stateCode,
                    uscdCode:  s.geo.uscdCode,
                    ssdCode:  s.geo.ssdCode,
                    zipCode:  s.geo.zipCode,
                    // color: highlightColor
                    fillValue: s.ISSUE_FBACK_COUNT,
                    level: "default"
                }

                if(this.state.geo.level === "SSD") {
                    highlight.level = "ZIP"
                }
                
                return highlight
            })


            const { mapHighlights: oldHighlights } = this.state

            log.debug("handleTableRowHover(): STICKY: newHighlights =", newHighlights)
            log.debug("handleTableRowHover(): SITCKY: oldHighlights =", oldHighlights)

            const mergedHighlights = [
                //...oldHighlights.filter(h => h.sticky),
                ...newHighlights
            ]

            const finalHighlights = mergedHighlights
                  .map(h => { h.source = "issue-table-row-hover"; return h })
            

            this.setState({
                mapHighlights: finalHighlights
            })
        }
    }
*/
            
    handleTableRowUnhover = row => {
        //return
        log.trace("handleTableRowUnhover(): row =", row)

        const { mapHighlights: oldHighlights } = this.state
        log.trace("handleTableRowUnhover(): STICKY: unhover: oldHighlights =", oldHighlights)
        
        const finalHighlights = oldHighlights
              .filter(h => h.sticky) // filter in the sticky ones
              .map(h => { h.source = "issue-table-row-unhover"; return h })


        log.trace("handleTableRowUnhover(): STICKY: unhover: finalHighlights =", finalHighlights)
        
        //const highlights = []
        this.setState({
            mapHighlights: finalHighlights
        })
    }


    handleTableChartUnhover = row => {
        //return
        log.trace("handleTableChartUnhover(): row =", row)

        const { mapHighlights: oldHighlights } = this.state
        log.trace("handleTableChartUnhover(): STICKY: unhover: oldHighlights =", oldHighlights)
        
        const finalHighlights = oldHighlights
              .filter(h => h.sticky) // filter in the sticky ones
              .map(h => { h.source = "issue-table-row-unhover"; return h })


        log.trace("handleTableChartUnhover(): STICKY: unhover: finalHighlights =", finalHighlights)
        
        //const highlights = []
        this.setState({
            mapHighlights: finalHighlights
        })
    }
    
    render() {
        const { classes, history } = this.props

        // redirects first
        if(this.state.redirectToSDash) {
            log.trace("render(): redirect to IDash")
            return <Redirect push to="/sdash"/>
        } else if(this.state.redirectToIDashState) {
            const url = history.location.pathname + history.location.search
            log.trace("render(): redirecting to itself to redraw, url = ", url)
            return <Redirect to={url}/>
            // return <Redirect push to="/idash-state"/>
        } else if(this.state.redirectToSelf) {
            // NEXT: do this here too for the sdash
            const url = history.location.pathname + history.location.search
            log.trace("render(): redirecting to itself to redraw, url = ", url)
            return <Redirect to={url}/>
        }


//        let showFilter = true
        let filterMd, filterSm,
            mapMd, mapSm,
            tableMd, tableSm,
            // eslint-disable-next-line    
            issueTrendMd, issueTrendSm
        let mainDivClass

        if(this.state.showFilter) {
            issueTrendMd = 12
            issueTrendSm = 12
            filterMd = 2
            filterSm = 12
            mapMd = 5
            mapSm = 12
            tableMd = 5
            tableSm = 12
            mainDivClass = classes.mainDivFilter
        } else {
            issueTrendMd = 12
            issueTrendSm = 12
            filterMd = 0
            filterSm = 0
            mapMd = 6
            mapSm = 12
            tableMd = 6
            tableSm = 12
            mainDivClass = classes.mainDiv
        }

        log.trace("render(): this.state.geo =", this.state.geo)

        let mapHeader1Text, mapHeader2Text,
            geoFilterHeader1Text, geoFilterHeader2Text
        
        // GEO_SPECIFIC
        if(this.state.geo.level === "STATE") {
            mapHeader1Text = "State Map with Congressional Districts"
            mapHeader2Text = "Hover over a District to see its activity or click to view it in detail"
            geoFilterHeader1Text = "Filter"
            geoFilterHeader2Text = "Click to Select District"
        }  else if(this.state.geo.level === "SSD") {
            mapHeader1Text = "State Map with State Senate Districts"
            mapHeader2Text = "Hover over a District to see its activity or click to view it in detail"
            geoFilterHeader1Text = "Filter"
            geoFilterHeader2Text = "Click to Select District"
            
        } else if(this.state.geo.level === "USCD") {
            mapHeader1Text = "District Map with Zip Codes"
            mapHeader2Text = "Hover over a Zip Code to see its activity or click to view it in detail"
            geoFilterHeader1Text = "Filter"
            geoFilterHeader2Text = "Click to Select Zip Code"
        } else if(this.state.geo.level === "NATIONAL") {
            // mapHeader1Text = "Interactive National Map with States"
            mapHeader1Text = "Interactive National Map"
            mapHeader2Text = "Hover over a State to see its activity or click to view it in detail"
            geoFilterHeader1Text = "Filter"
            geoFilterHeader2Text = "Click to Select State"
        }


        const nationalGeo = {
            level: "NATIONAL"
        }

        const stateGeo = {
            level: "STATE",
            stateCode: "CA"
        }

        /*
          const uscdGeo = {
          level: "USCD",
          stateCode: "CA",
          uscdCode: "14"
        }
        */

        const ssdGeo = {
            level: "SSD",
            stateCode: "CA"
        }

	return(
            <React.Fragment>
	      <CssBaseline/>

              <div ref={(el) => { this.headDivEl = el }} ></div>

              <FlashTopBar text="Issue Dashboard" variation={this.state.variation}/>
              
              <div className={mainDivClass}>

                {/* GEO_SPECIFIC */}


                 { this.state.geo.level === "SSD" &&
                   <span>
                   <FlashHeader text="State Senate District View"/>
                   <Typography className={classes.subheaderText} variant="h6" style={{fontSize: 28, color:"#448cff", marginLeft: 25, marginTop: 20, marginBottom: 10, marginRight: 25}}>
                   - {`${getStateName(this.state.geo.stateCode)}`}
                   </Typography>
                   </span>
                 }
                
                 
                 { this.state.geo.level === "USCD" &&
                   <span>
                   <FlashHeader text="US Congressional District View"/>
                   <Typography className={classes.subheaderText} variant="h6" style={{fontSize: 28, color:"#448cff", marginLeft: 25, marginTop: 20, marginBottom: 10, marginRight: 25}}>
                   - {`${getStateName(this.state.geo.stateCode)} District ${this.state.geo.uscdCode}`}
                   </Typography>
                   </span>
                 }

                 { this.state.geo.level === "STATE" &&
                   <span>
                     <FlashHeader text="US State View"/>
                     <Typography className={classes.subheaderText} variant="h6" style={{fontSize: 28, color:"#448cff", marginLeft: 25, marginTop: 20, marginBottom: 10, marginRight: 25}}>
                       - {`${getStateName(this.state.geo.stateCode)}`}
                     </Typography>
                   </span>
                 }


                 { this.state.geo.level === "NATIONAL" &&
                   <span>
                     <FlashHeader text="National View"/>
                     <Typography className={classes.subheaderText} variant="h6" style={{fontSize: 28, color:"#448cff", marginLeft: 25, marginTop: 20, marginBottom: 10, marginRight: 25}}>
                       - USA
                </Typography>
                   </span>
                 }



                <button className={classes.jumpToButton} onClick={() => {
                    history.push(`/idash?geo=${encodeURIComponent(JSON.stringify(nationalGeo))}`)
                    this.setState({redirectToSelf: true})
                    log.debug("button national")
                }}>National</button>

                {/*
                <button className={classes.jumpToButton} onClick={() => {
                  history.push(`/idash?geo=${encodeURIComponent(JSON.stringify(stateGeo))}`)
                  this.setState({redirectToSelf: true})
                  log.debug("button state")
                  }}>Jump to {JSON.stringify(stateGeo)}</button>
                 */}

                {/*
                <button className={classes.jumpToButton} onClick={() => {
                  history.push(`/idash?geo=${encodeURIComponent(JSON.stringify(uscdGeo))}`)
                  this.setState({redirectToSelf: true})
                  log.debug("button uscd")
              }}>Jump to {JSON.stringify(uscdGeo)}</button>
                 */}


                {/*
                <button className={classes.jumpToButton} onClick={() => {
                  history.push(`/idash?geo=${encodeURIComponent(JSON.stringify(ssdGeo))}`)
                  this.setState({redirectToSelf: true})
                  log.debug("button ssdGeo")
              }}>Jump to {JSON.stringify(ssdGeo)}</button>
                 */}

                { (this.state.geo.level === "STATE" ||  this.state.geo.level === "SSD" || this.state.geo.level === "USCD") &&
                <span>
                <button className={classes.jumpToButton} onClick={() => {
                  history.push(`/idash?geo=${encodeURIComponent(JSON.stringify(stateGeo))}`)
                  this.setState({redirectToSelf: true})
                  log.debug("button state")
                }}>US Congresstional Districts</button>

                
                <button className={classes.jumpToButton} onClick={() => {
                  history.push(`/idash?geo=${encodeURIComponent(JSON.stringify(ssdGeo))}`)
                  this.setState({redirectToSelf: true})
                  log.debug("button ssdGeo")
              }}>State Senate Districts</button>
                </span>
                 }                

            {this.state.isTooSmall &&
                     <Typography variant="h6" style={{fontSize: 26, color:"#65676b", marginLeft: 25, marginTop: 20, marginBottom: 20, marginRight: 25}}>
                       <p>At this time, Dashboard works best on <b>Desktop</b>.</p>
                       <p>Please re-open on a large screen.</p>
                       <p>Thank you for testing!</p>
                </Typography>
            }             

                
            {!this.state.isTooSmall &&
                <Grid container classes={{
                    container: classes.gridContainer
                }} spacing={2}>

                  { this.state.showFilter &&
                    <Grid item md={filterMd} sm={filterSm} classes={{}}>
                      <DashGeoFilter
                        header1={geoFilterHeader1Text}
                        header2={geoFilterHeader2Text}
                        txtName="Zip Code"
                        showPlace={false}
                        dataset={this.state.geoFilterDataset}
                        onRowHover={this.handleGeoFilterRowHover}
                        onRowUnhover={this.handleGeoFilterRowUnhover}
                        onRowClick={this.handleGeoFilterRowClick}
                        align="left"
                      />
                    </Grid>
                  }
                  

                  <Grid item md={mapMd} sm={mapSm} classes={{}}>
                    <div style={{
                        //                          minHeight: "100%!important",
                        //                        backgroundColor: "grey"
                        // height: "100%!important"
                        height: "500px"
                    }}>
                      <DashMap
                        header1={mapHeader1Text}
                        header2={mapHeader2Text}
                        geo={this.state.geo}
                        dataset={this.state.mapDataset}
                        highlights={this.state.mapHighlights}
                        zoomTarget={this.state.mapZoomTarget}
                        onDoubleClick={this.handleMapDoubleClick}
                        onFilterClick={this.handleMapFilterClick}
                        onPushProperties={this.handleGeoFilterMapProperties}
                    />

                    </div>
                  </Grid>

                  <Grid item md={tableMd} sm={tableSm}>
                    <div style={{
                        // height: 500,
                        height: "700px"
                        // backgroundColor: "grey"
                    }}>
                      <DashTable
                        info="issues"
                        header1="Issues"
                        header2="Click on an issue to see its detail or hover over to see activity on the map"
                        txtName="Issue"
                        showPlace={false}
                        showBar2={false}
                        showBar3={true}
                        showMark1={true}
                        dataset={this.state.tableDataset}
                        onChartHover={this.handleTableChartHover}
                        onChartUnhover={this.handleTableChartUnhover}
                        onRowHover={this.handleTableRowHover}
                        onRowUnhover={this.handleTableRowUnhover}
                        onRowClick={this.handleTableRowClick}
                      />
                    </div>
                  </Grid>
             </Grid>
            }
              </div>


              { this.state.scrollerDirection && this.state.scrollerDirection === "down" &&
                <Fab aria-label="scroll"
                     className={clsx(classes.fab, classes.fabGreen)}
                     onClick={this.scrollToBottom}>
                  <DownIcon style={{fontSize: 50}}/>
                </Fab>
              }

              { this.state.scrollerDirection && this.state.scrollerDirection === "up" &&
                <Fab aria-label="scroll"
                     className={clsx(classes.fab, classes.fabGreen)}
                     onClick={this.scrollToTop}>
                  <UpIcon style={{fontSize: 50}}/>
                </Fab>
              }

              <div style={{padding: 40}}></div> {/* fakish padding for now*/}

              <div ref={(el) => { this.tailDivEl = el }} ></div>
              
            </React.Fragment>
	)
    }
}

IDash.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles, {name: "IDash"})(IDash)

